<div class="leave-modal-content">
  @if (isFromSubOrgPage) {
    <div>Leaving this sub-organization will remove your direct role here and related services.</div>
    <div>
      You might still be able to access services in {{ orgName }} if you have an inherited role from the parent
      organization.
    </div>
  } @else {
    <div>Leaving this organization will revoke your access to all applications and data you created within it.</div>
    <div>You might still see {{ orgName }} listed if you hold a role in one of its sub-organizations.</div>
    <div>To rejoin, administrator approval will be required.</div>
  }
</div>
